export const isDevelopmentEnvironment = process.env.REACT_APP_API_BASE_URL?.toUpperCase().includes('DEV') ?? false;
const isDevelopment = isDevelopmentEnvironment;

export const logger = {
    log: (...args: Array<any>) => {
        if (isDevelopment) {
            console.log(...args);
        }
    },
    error: (...args: Array<any>) => {
        if (isDevelopment) {
            console.error(...args);
        }
    },
    warn: (...args: Array<any>) => {
        if (isDevelopment) {
            console.warn(...args);
        }
    }
}